import React, { useEffect } from "react";
import "./OurProcess.css";

const OurProcess = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    document
      .querySelectorAll(".process-container, .process-left, .process-box")
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="our-process-section">
      <div className="process-container">
        {/* Left Hexagon */}
        <div className="process-left">
          <div className="hexagon">
            <h2>Our Process</h2>
          </div>
        </div>

        {/* Right Steps */}
        <div className="process-right">
          <div className="process-box delay-1">
            <span className="step-number">1</span>
            <p>Source globally, deliver locally</p>
          </div>

          <div className="process-box delay-2">
            <span className="step-number">2</span>
            <p>Provide 24×7 after-sales maintenance</p>
          </div>

          <div className="process-box delay-3">
            <span className="step-number">3</span>
            <p>Support you with import assistance when you need it most</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurProcess;
